/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';
import useOnClickOutside from '../../hooks/useOnClickOutside';

export default function Dropdown({
  currentOption,
  setCurrentOption,
  options,
  placeholder,
}) {
  const [areOptionsVisible, setAreOptionsVisible] = useState(false);

  const dropdownRef = useRef();
  useOnClickOutside(dropdownRef, () => setAreOptionsVisible(false));

  const selectedOptionData = options.find(
    (option) => option?.value === currentOption
  );

  return (
    <div className={classes.Dropdown} ref={dropdownRef}>
      <div
        className={classNames(classes.selector, {
          [classes.open]: areOptionsVisible,
          [classes.hasIcon]: !!selectedOptionData?.activeIcon,
        })}
        onClick={() => setAreOptionsVisible((prevState) => !prevState)}
      >
        {selectedOptionData?.activeIcon && (
          <div className={classes.iconContainer}>
            {currentOption.activeIcon}
          </div>
        )}
        {selectedOptionData?.label || (
          <span className={classes.placeholder}>{placeholder}</span>
        )}
        <div className={classes.chevron} />
      </div>
      {areOptionsVisible && (
        <ul className={classes.optionsList}>
          {options.map((option) => {
            if (option.value !== currentOption) {
              return (
                <li
                  className={classNames({
                    [classes.hasIcon]: !!option.icon,
                  })}
                  key={option.value}
                  onClick={() => {
                    setCurrentOption(option.value);
                    setAreOptionsVisible(false);
                  }}
                >
                  {option.icon && (
                    <div
                      className={classNames(
                        classes.iconContainer,
                        classes.iconBackground
                      )}
                    >
                      {option.icon}
                    </div>
                  )}
                  {option.label || option.value}
                </li>
              );
            }
            return null;
          })}
        </ul>
      )}
    </div>
  );
}
